export default {
  root: {
    backgroundColor: '#F6F9FD',
    color: '#425A70'
  },
  clickable: {
    '&:hover, &:focus, &:active': {
      backgroundColor: '#EDF0F2'
    }
  },
  deletable: {
    '&:focus': {
      backgroundColor: '#F6F9FD'
    }
  },
  outlined: {
    '&:hover': {
      backgroundColor: '#F6F9FD'
    }
  }
};
